import React from 'react'

export const Header = () => {
  return (
    <div className='header'>
      <a href='/'><img src='/assets/mutantcartel_logo.png' alt='logo' /></a>
    </div>
  )
}
